import React, { Component } from 'react'

import _ from 'lodash'

import './SwipeAdContent.css'

export class SwipeAdContent extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        // If nextProps.renderedPreviewIndexes contains the nextProps.previewIndex, 
        // it indicates that the prevew at nextProps.previewIndex is already rendered.
        // In this case do not render the content again.
        if(_.includes(nextProps.renderedPreviewIndexes, nextProps.previewIndex)) {
            return false;
        }

        return true;
    }
    render() {
        return (
        <div className="swipe-ad-content">
              { this.props.content }
        </div>
        )
    }
}

export default SwipeAdContent



// WEBPACK FOOTER //
// ./src/components/common/SwipeAdContent/SwipeAdContent.jsx